// import React from "react";
// import {
//   Box,
//   Container,
//   Grid,
//   Typography,
//   Link,
//   IconButton,
//   Avatar,
// } from "@mui/material";
// import { Facebook, Instagram, Twitter, GitHub } from "@mui/icons-material";
// import ComapanyLogo from "../../Assets/file.png";

// const Footer = () => {
//   return (
//     <Box
//       component="footer"
//       sx={{
//         background: "linear-gradient(135deg, #3f51b5, #1a237e)",
//         color: "white",
//         py: 4,
//         mt: 6,
//         mb: 0,
//       }}
//     >
//       <Container maxWidth="lg">
//         <Box
//           mt={4}
//           display="flex"
//           alignItems="center"
//           justifyContent="space-between"
//           flexDirection={{ xs: "column", md: "row" }}
//           gap={2}
//         >
//           <Typography variant="body2" color="inherit">
//             © {new Date().getFullYear()} InfyU Labs, All rights reserved.
//           </Typography>
//           <Box>
//             <IconButton
//               href="#"
//               color="inherit"
//               sx={{
//                 transition: "transform 0.3s ease, color 0.3s ease",
//                 "&:hover": { transform: "scale(1.2)", color: "#ffeb3b" },
//               }}
//             >
//               <Facebook />
//             </IconButton>
//             <IconButton
//               href="#"
//               color="inherit"
//               sx={{
//                 transition: "transform 0.3s ease, color 0.3s ease",
//                 "&:hover": { transform: "scale(1.2)", color: "#ffeb3b" },
//               }}
//             >
//               <Instagram />
//             </IconButton>
//             <IconButton
//               href="#"
//               color="inherit"
//               sx={{
//                 transition: "transform 0.3s ease, color 0.3s ease",
//                 "&:hover": { transform: "scale(1.2)", color: "#ffeb3b" },
//               }}
//             >
//               <Twitter />
//             </IconButton>
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default Footer;


///////////////////////////Rishabh Version start/////////////////////////



import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Instagram,
  LinkedIn,
  Pinterest,
  Twitter,
  Email,
  SportsBasketball,
} from "@mui/icons-material";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        background: "linear-gradient(135deg, #152D85, #1E40AF)",
        color: "#FFFFFF",
        py: isMobile ? 2 : 4, // Reduce vertical padding on mobile
        px: 2,
        mt: 6,
        overflow: "hidden",
      }}
    >
      {/* Wave SVG at top */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "50px", // Smaller wave height
          background:
            "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 1440 320' xmlns='http://www.w3.org/2000/svg'><path fill='%230b1c1e' fill-opacity='1' d='M0,160L80,144C160,128,320,96,480,112C640,128,800,192,960,213.3C1120,235,1280,213,1360,202.7L1440,192V0H0Z'></path></svg>\") no-repeat",
          backgroundSize: "cover",
          zIndex: 0,
          transform: "translateY(-100%)",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid
          container
          spacing={isMobile ? 2 : 3}
          alignItems="flex-start"
          direction={isMobile ? "column" : "row"}
        >
          {/* Left Section */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 1,
                color: "#FFFFFF",
                fontSize: isMobile ? "1rem" : "1.25rem",
              }}
            >
              Get in Touch
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 1.5,
                color: "rgba(255,255,255,0.7)",
                fontSize: isMobile ? "0.75rem" : "0.875rem",
              }}
            >
              © 2025 InfyU Labs, All rights reserved.
              <br />
            
            </Typography>

            <Box display="flex" gap={1} flexWrap="wrap">
              {[Instagram, LinkedIn, Pinterest, Twitter].map((Icon, idx) => (
                <IconButton
                  key={idx}
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    color: "#FFFFFF",
                    width: isMobile ? 30 : 36,
                    height: isMobile ? 30 : 36,
                    p: isMobile ? 0.5 : 1,
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.25)",
                    },
                  }}
                >
                  <Icon fontSize="small" />
                </IconButton>
              ))}
            </Box>
          </Grid>

          {/* Right Section */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={1.5}>
              {[{ icon: <SportsBasketball />, text: "dribbble.com/example" }, { icon: <Email />, text: "contact@example.com" }].map((item, i) => (
                <Grid item xs={12} sm={6} key={i}
                  sx={{
                    display: isMobile ? "none" : "block", // Hide on mobile
                  }}
                >
                  <Box position="relative">
                    <Box
                      sx={{
                        position: "absolute",
                        top: 6,
                        left: 6,
                        width: "100%",
                        height: "100%",
                        borderRadius: 2,
                        bgcolor: "rgba(255,255,255,0.05)",
                        zIndex: 0,
                      }}
                    />
                    <Card
                      sx={{
                        backgroundColor: "rgba(255,255,255,0.1)",
                        color: "#FFFFFF",
                        borderRadius: 2,
                        position: "relative",
                        zIndex: 1,
                      }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          py: 1.5,
                          gap: 0.5,
                        }}
                      >
                        {item.icon}
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: "0.8rem",
                          }}
                        >
                          {item.text}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
